import { THEMES, ThemeId, DEFAULT_THEME_ID, isThemeId } from './themes';
import { deriveBrandTokens } from './colors';

export const THEME_STORAGE_KEY = 'menulynx.themeId';

export function applyTheme(
  themeId: string,
  brandColor?: string,
  accentColor?: string,
  root: HTMLElement = document.documentElement,
): void {
  const resolved: ThemeId = isThemeId(themeId) ? themeId : DEFAULT_THEME_ID;

  root.setAttribute('data-theme', resolved);

  const base = THEMES[resolved];
  Object.entries(base).forEach(([name, value]) => root.style.setProperty(name, value));

  if (brandColor) {
    Object.entries(deriveBrandTokens(brandColor)).forEach(([name, value]) =>
      root.style.setProperty(name, value),
    );
  }
  if (accentColor) {
    root.style.setProperty('--color-accent', accentColor);
  }

  try {
    localStorage.setItem(THEME_STORAGE_KEY, resolved);
  } catch {
    /* private mode / storage disabled — non-fatal */
  }
}
